module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABS0lEQVQ4T6WTTVKDQBCFu0HIzsSdVQYMG4WdnkA5gXoET2A8gfEExhPoDeQGcgOzA92QgljlErMLI9MWY6CQv4pl76bn9Veve6YR/hnYVf+2pxxl9wfvbNam6wR4ujpHAOotk2MjhrgJ0grwdHWCADdZEQHcWmEy2RgQDGCw2lYCAvzMihCo31syo8lFowN/qExBwivi3JYJYy7jC3C6NxdsXHVRA3i7MEJVDYR1zm1r8eX6ukrinCSG9QHzMqQG8DXVAYSzJgAQOGaUXLQCvOHWKUrScy6oOihDc80vB56muIh4UgYUMyiS5JoRs2uAV00+J5SfKkPK+x2V80R0aUXs8eeF1rH+NPtVoRAhPlTBZpgYBcDXlTEA3tWeiFIxsAZnWfbaDNlUOPB1JQbA/t/2imIzZDsCkPXPURaLs2lIlM4Oo9TpXKZNYN9jz48RWWMiVAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warn_icon1.png
// module id = 187
// module chunks = 1